"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesNonceManagerMethods = exports.NonceSeriesV2 = exports.NonceSeriesLegacyV1 = void 0;
/**
 * @deprecated
 */
exports.NonceSeriesLegacyV1 = {
    P2Pv2: BigInt(1),
};
exports.NonceSeriesV2 = {
    /**
     * This is not a valid option.
     *
     * @deprecated Gasless should use main contract's built-in nonce manager
     * to avoid arbitraryStaticCall() and save gas.
     */
    GaslessV3: BigInt(-1),
    // Those are valid
    _GaslessV3: BigInt(-1),
    LimitOrderV3: BigInt(0),
    P2PV3: BigInt(1),
};
var SeriesNonceManagerMethods;
(function (SeriesNonceManagerMethods) {
    SeriesNonceManagerMethods["nonce"] = "nonce";
    SeriesNonceManagerMethods["advanceNonce"] = "advanceNonce";
    SeriesNonceManagerMethods["increaseNonce"] = "increaseNonce";
    SeriesNonceManagerMethods["nonceEquals"] = "nonceEquals";
    // Don't expose timestampBelow as it's usless.
    SeriesNonceManagerMethods["timestampBelowAndNonceEquals"] = "timestampBelowAndNonceEquals";
})(SeriesNonceManagerMethods = exports.SeriesNonceManagerMethods || (exports.SeriesNonceManagerMethods = {}));
//# sourceMappingURL=series-nonce-manager.model.js.map